export * from 'server/models/PortCallReport';


// WEBPACK FOOTER //
// ./data/models/PortCallReport.ts